'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = null;
var intlImp = null;

var arabicDigits = [String.fromCharCode(1632), String.fromCharCode(1633), String.fromCharCode(1634), String.fromCharCode(1635), String.fromCharCode(1636), String.fromCharCode(1637), String.fromCharCode(1638), String.fromCharCode(1639), String.fromCharCode(1640), String.fromCharCode(1641)];

var ARABIC_COMMA = String.fromCharCode(1643);
var arabicRegex = new RegExp(arabicDigits.join('|'), 'g');
var arabicCommaRegex = new RegExp(ARABIC_COMMA, 'g');

function getIntl() {
    if (intlImp) return intlImp;else return Intl;
}

exports.default = {

    getLocalSeparator: function getLocalSeparator() {
        var _locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : locale;

        _locale = _locale.replace(/_/, '-');

        var num = new getIntl().NumberFormat(_locale, { style: 'decimal' }).format(12.5);

        return num.indexOf(',') > -1 ? ',' : '.';
    },

    parse: function parse(text) {
        var _locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : locale;

        _locale = _locale.replace(/_/, '-');

        // First, test if the current locale is with ',' or '.' as a fraction separator
        // Possible enhancement - to cache the result based on locale
        var num = new getIntl().NumberFormat(_locale, { style: 'decimal' }).format(12.5);

        if (num.indexOf(',') > -1) {
            text = text.replace(/\./g, '').replace(/ /, '').replace(/\,/g, '.');
        } else if (num.indexOf(ARABIC_COMMA) > -1) {
            text = text.replace(/\./g, '').replace(/ /, '').replace(arabicCommaRegex, '.');
        } else {
            text = text.replace(/\,/g, '').replace(/ /, '');
        }

        if (text.match(arabicRegex)) {
            text = text.replace(arabicRegex, function (c) {
                return String(arabicDigits.indexOf(c));
            });
        }

        return parseFloat(text);
    },

    format: function format(number, opt) {
        var _locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : locale;

        _locale = _locale.replace(/_/, '-');

        opt = opt || { style: 'decimal' };

        return new getIntl().NumberFormat(_locale, opt).format(number);
    },

    init: function init(_locale, _intlImp) {
        intlImp = _intlImp || intlImp || Intl;
        locale = _locale.replace(/_/, '-');
    },

    initIntl: function initIntl(_intlImp) {
        intlImp = _intlImp;
    }
};